type TModalParameters = Record<string, any>;

export type TModalData = {
    modalName?: string | null;
    entityName?: string;
    modalParameters?: TModalParameters;
    parentEntityName?: string;
}

export type TModalsSliceState = {
    modalData: TModalData;
}

export type TModalComponentInterface = {
    parameters?: TModalParameters;
    onClose: () => void;
}

export enum EModalType {
    documentsFileUpload = 'documentsFileUpload',
    documentsUploadStage = 'documentsUploadStage',
    documentsSignatureUpload = 'documentsSignatureUpload',
    editableTableModal = 'editableTableModal',
    formCreateItem = 'formCreateItem',
    formModal = 'formModal',
    formDrawer = 'formDrawer',
    filterDrawer = 'filterDrawer',
    formEditEntityModal = 'formEditEntityModal',
    filterModal = 'filterModal',
    requestFormModal = 'requestFormModal',
    listModal = 'listModal',
    listGridModal = 'listGridModal',
    documentComparisonModal = 'documentComparisonModal',
    downloadReportDocumentsModal = 'downloadReportDocumentsModal',
    documentCodesFormModal = 'documentCodesFormModal',
    settingProgramMappingModal = 'settingProgramMappingModal',
    reportColumnsSetting = 'reportColumnsSetting',
    historyModal = 'historyModal',
}
